import { isRobotUser } from '@akin-home/utils/native';
import { useStateStore } from '../../stores/useStateStore';
import { useRobotMessageListener } from '../websockets/hooks/useRobotMessageListener';

interface Props {
  children?: JSX.Element | null;
}

/**
 * A high level provider for robot based overlays and global actions
 */
const RobotProviderInner = (props: Props) => {
  const addItem = useStateStore((state) => state.addChatItem);

  useRobotMessageListener({
    addChatItem: addItem,
  });

  const { children = null } = props;
  return children;
};

/**
 * A component that conditionally includes wrapper provider components and hooks if the user is a robot user
 */
export const RobotProvider = (props: Props) => {
  const { children = null } = props;

  // Conditionally apply the robot provider wrapper if this is a robot user.
  if (isRobotUser()) {
    return <RobotProviderInner>{children}</RobotProviderInner>;
  } else {
    return children;
  }
};
